
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        data: {
            type: Array,
            default: () => {
                return []
            },
        },
        type: {
            type: String,
            default: '',
        },
        afterClass: {
            type: String,
            default: '',
        },
        color: {
            type: String,
            default: '',
        },
        textColor: {
            type: String,
            default: '',
        },
        borderColor: {
            type: String,
            default: '',
        },
        bookmania: Boolean,
        level: {
            default: 4,
            type: Number,
        },
        noPagination: Boolean,
        separator: Boolean,
    },

    data() {
        return {
            page: 1,
            per_page: 3,
        }
    },

    computed: {
        maxPage() {
            if (this.data) return Math.ceil(this.data.length / this.per_page)
            return null
        },

        paginatedData() {
            const perPage = this.per_page * this.page
            return this.data
                ? this.data.filter((el, idx) => {
                      return idx + 1 <= perPage
                  })
                : []
        },
    },

    mounted() {
        this.per_page = 1000
    },
}
